import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { isNull } from 'lodash';
import { Observable } from 'rxjs';

import { AuthService } from '../../shared/auth/auth.service';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const userToken: string = this.authService.getToken();
    let req = request;
    if (!isNull(userToken)) {
      req = request.clone({
        setHeaders: {
          Authorization: `Bearer ${userToken}`,
        }
      });
    }
    return next.handle(req);
  }
}
